var imageList = [];
var storeSizesGlobal;
var selective_size_rpw = 2950.0;

function fetchDataEpsMemory(data, storeSizes, sci_sizes) {
    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var lines = data.split('\n');

        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            var words = line.trim().split('\t');

            if (words.length > 0 && words[0].includes('Data_store:') && !words[0].includes('#')) {
                storeSizes[words[1]] = parseFloat(words[4]);
            }
        }

        for (var key in storeSizes) {
            if (storeSizes.hasOwnProperty(key) && key.includes('SCI')) {
                sci_sizes.push(storeSizes[key]);
            }
        }
    } catch (error) {
        console.error("Error loading file:", error);
    }
}

function fetchDataEps(data, dataArr) {
    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var columnNames = ['DDATE', 'DL', 'Tot_Accum_DL', 'tot_mem', 'tot_mem_acc', 'OMM_Mem', 'OMM_Accum', 'PYLDHK_Mem', 'PYLDHK_Accum',
            'LL_Mem', 'LL_Accum', 'SSMM_TAC_Mem', 'SSMM_TAC_Accum', 'EPD_SSMM', 'SSMM_EPD_Accum', 'EUI_SSMM',
            'SSMM_EUI_Accum', 'MAG_SSMM', 'SSMM_MAG_Accum', 'MET_SSMM', 'SSMM_MET_Accum', 'PHI_SSMM',
            'SSMM_PHI_Accum', 'RPW_SSMM', 'SSMM_RPW_Accum', 'SHI_SSMM', 'SSMM_SHI_Accum', 'SPI_SSMM',
            'SSMM_SPI_Accum', 'STX_SSMM', 'STX_Accum', 'SWA_SSMM', 'SSMM_SWA_Accum', 'SSMM_MAG_TRG_Mem',
            'SSMM_MAG_TRG_Accum', 'SSMM_SD1_Mem', 'SSMM_SD1_Acumm', 'SSMM_SD2_Mem', 'SSMM_SD2_Acumm',
            'SSMM_SD3_Mem', 'SSMM_SD3_Acumm', 'SSMM_SD4_Mem', 'SSMM_SD4_Acumm', 'SSMM_SD5_Mem', 'SSMM_SD5_Acumm',
            'SSMM_SD6_Mem', 'SSMM_SD6_Acumm', 'SSMM_SD7_Mem', 'SSMM_SD7_Acumm', 'SSMM_SD8_Mem', 'SSMM_SD8_Acumm',
            'SSMM_SD9_Mem', 'SSMM_SD9_Acumm', 'SSMM_SD0_Mem', 'SSMM_SD0_Acumm', 'EUI_Upld', 'EUI_Downld',
            'EUI_Mem', 'EUI_Accum', 'MET_Upld', 'MET_Downld', 'MET_Mem', 'MET_Accum', 'PHI_Upld', 'PHI_Downld',
            'PHI_Mem', 'PHI_Accum', 'SHI_Upld', 'SHI_Downld', 'SHI_Mem', 'SHI_Accum', 'SPI_Upld', 'SPI_Downld',
            'SPI_Mem', 'SPI_Accum', 'STX_Upld', 'STX_Downld', 'STX_Mem', 'STX_Accum', 'EPD_Upld', 'EPD_Downld',
            'EPD_Mem', 'EPD_Accum', 'MAG_Upld', 'MAG_Downld', 'MAG_Mem', 'MAG_Accum', 'RPW_Upld', 'RPW_Downld',
            'RPW_Mem', 'RPW_Accum', 'SWA_Upld', 'SWA_Downld', 'SWA_Mem', 'SWA_Accum', 'PF_Upld', 'PF_Downld',
            'PF_Mem', 'PF_Accum'
        ];

        var rows = data.split("\n");
        for (var i = 25; i < rows.length; i++) {
            var row = rows[i].split(",");
            var obj = {};
            for (var j = 0; j < columnNames.length; j++) {
                obj[columnNames[j]] = row[j];
            }
            dataArr.push(obj);
        }

    } catch (error) {
        console.error("Error loading file:", error);
    }
}

function fetchDataEpsPasses(data, dataArrUnd) {

    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var columnNamesUnd = ['Pass', 'DDATE', 'EndTime', 'Duration', 'Overall_Pass_Capacity', 'Overall_Used_Capacity',
            'Overall_Unused_Capacity', 'HGA_Pass_Capacity', 'HGA_Used_Capacity', 'HGA_Unused_Capacity'
        ];

        var rows = data.split("\n");
        for (var i = 24; i < rows.length; i++) {
            var row = rows[i].split(",");
            var obj = {};
            for (var j = 0; j < columnNamesUnd.length; j++) {
                obj[columnNamesUnd[j]] = row[j];
            }
            dataArrUnd.push(obj);
        }

    } catch (error) {
        console.error("Error loading file:", error);
    }

}

// General Fucntions to extract data
function fetchDataLat(data, dataArr) {

    if (!data) {
        console.warn("No Data file selected. Falling back to default path.");
        return;
    }

    var columnNames = ['DDATE', 'OMM_first', 'OMM_last', 'OMM_remain', 'OMM_over', 'OMM_down', 'SSMM_PYLD_HK_first', 'SSMM_PYLD_HK_last',
        'SSMM_PYLD_HK_remain', 'SSMM_PYLD_HK_over', 'SSMM_PYLD_HK_down', 'SSMM_PYLD_LL_first',
        'SSMM_PYLD_LL_last', 'SSMM_PYLD_LL_remain', 'SSMM_PYLD_LL_over', 'SSMM_PYLD_LL_down', 'SSMM_TAC_first',
        'SSMM_TAC_last', 'SSMM_TAC_remain', 'SSMM_TAC_over', 'SSMM_TAC_down', 'SSMM_EPD_SCI_first',
        'SSMM_EPD_SCI_last', 'SSMM_EPD_SCI_remain', 'SSMM_EPD_SCI_over', 'SSMM_EPD_SCI_down',
        'SSMM_EUI_SCI_first', 'SSMM_EUI_SCI_last', 'SSMM_EUI_SCI_remain', 'SSMM_EUI_SCI_over',
        'SSMM_EUI_SCI_down', 'SSMM_MAG_SCI_first', 'SSMM_MAG_SCI_last', 'SSMM_MAG_SCI_remain',
        'SSMM_MAG_SCI_over', 'SSMM_MAG_SCI_down', 'SSMM_MET_SCI_first', 'SSMM_MET_SCI_last',
        'SSMM_MET_SCI_remain', 'SSMM_MET_SCI_over', 'SSMM_MET_SCI_down', 'SSMM_PHI_SCI_first',
        'SSMM_PHI_SCI_last', 'SSMM_PHI_SCI_remain', 'SSMM_PHI_SCI_over', 'SSMM_PHI_SCI_down',
        'SSMM_RPW_SCI_first', 'SSMM_RPW_SCI_last', 'SSMM_RPW_SCI_remain', 'SSMM_RPW_SCI_over',
        'SSMM_RPW_SCI_down', 'SSMM_SHI_SCI_first', 'SSMM_SHI_SCI_last', 'SSMM_SHI_SCI_remain',
        'SSMM_SHI_SCI_over', 'SSMM_SHI_SCI_down', 'SSMM_SPI_SCI_first', 'SSMM_SPI_SCI_last',
        'SSMM_SPI_SCI_remain', 'SSMM_SPI_SCI_over', 'SSMM_SPI_SCI_down', 'SSMM_STX_SCI_first',
        'SSMM_STX_SCI_last', 'SSMM_STX_SCI_remain', 'SSMM_STX_SCI_over', 'SSMM_STX_SCI_down',
        'SSMM_SWA_SCI_first', 'SSMM_SWA_SCI_last', 'SSMM_SWA_SCI_remain', 'SSMM_SWA_SCI_over',
        'SSMM_SWA_SCI_down', 'SSMM_MAG_TRG_first', 'SSMM_MAG_TRG_last', 'SSMM_MAG_TRG_remain',
        'SSMM_MAG_TRG_over', 'SSMM_MAG_TRG_down', 'SSMM_SD1_first', 'SSMM_SD1_last', 'SSMM_SD1_remain',
        'SSMM_SD1_over', 'SSMM_SD1_down', 'SSMM_SD2_first', 'SSMM_SD2_last', 'SSMM_SD2_remain', 'SSMM_SD2_over',
        'SSMM_SD2_down', 'SSMM_SD3_first', 'SSMM_SD3_last', 'SSMM_SD3_remain', 'SSMM_SD3_over', 'SSMM_SD3_down',
        'SSMM_SD4_first', 'SSMM_SD4_last', 'SSMM_SD4_remain', 'SSMM_SD4_over', 'SSMM_SD4_down', 'SSMM_SD5_first',
        'SSMM_SD5_last', 'SSMM_SD5_remain', 'SSMM_SD5_over', 'SSMM_SD5_down', 'SSMM_SD6_first', 'SSMM_SD6_last',
        'SSMM_SD6_remain', 'SSMM_SD6_over', 'SSMM_SD6_down', 'SSMM_SD7_first', 'SSMM_SD7_last',
        'SSMM_SD7_remain', 'SSMM_SD7_over', 'SSMM_SD7_down', 'SSMM_SD8_first', 'SSMM_SD8_last',
        'SSMM_SD8_remain', 'SSMM_SD8_over', 'SSMM_SD8_down', 'SSMM_SD9_first', 'SSMM_SD9_last',
        'SSMM_SD9_remain', 'SSMM_SD9_over', 'SSMM_SD9_down', 'SSMM_SD0_first', 'SSMM_SD0_last',
        'SSMM_SD0_remain', 'SSMM_SD0_over', 'SSMM_SD0_down'
    ];

    var rows = data.split("\n");
    for (var i = 27; i < rows.length; i++) {
        var row = rows[i].split(",");
        var obj = {};
        for (var j = 0; j < columnNames.length; j++) {
            obj[columnNames[j]] = row[j];
        }
        dataArr.push(obj);
    }
    console.log(dataArr);
}

// Functions and global variables for particular plots

// NonSci
var ommMemTrace;
var pyldhkMemTrace;
var llMemTrace;
var ssmmTacMemTrace;
var ommMemDashedTrace;
var pyldhkMemDashedTrace;
var llMemDashedTrace;
var ssmmTacMemDashedTrace;

 // RS
var euiSsmmDashedTrace;
var metSsmmDashedTrace;
var phiSsmmDashedTrace;
var shiSsmmDashedTrace;
var spiSsmmDashedTrace;
var stxSsmmDashedTrace;
 // IS
var epdSsmmDashedTrace;
var magSsmmDashedTrace;
var rpwSsmmDashedTrace;
var swaSsmmDashedTrace;
// selective limit
var rpwSsmmDottedTrace;

 // IS_Norm
var epdSsmmTrace;
var magSsmmTrace;
var rpwSsmmTrace;
var swaSsmmTrace;

 // RateIS
var epdDownldTrace;
var magDownldTrace;
var rpwDownldTrace;
var swaDownldTrace;

 // RateRS
var metDownldTrace;
var shiDownldTrace;
var spiDownldTrace;
var stxDownldTrace;

 // OutputAccumFlsh
var phiAccumTrace;
var euiAccumTrace;

 // OutputAccumFlsh
var dlTrace;
function extractDataTraces(data) {

    // NonSci
    ommMemTrace         = createScatterTrace(data, 'OMM_Mem', 'red');
    pyldhkMemTrace      = createScatterTrace(data, 'PYLDHK_Mem', 'blue');
    llMemTrace          = createScatterTrace(data, 'LL_Mem', 'orange');
    ssmmTacMemTrace     = createScatterTrace(data, 'SSMM_TAC_Mem', 'green');

    ommMemDashedTrace       = createDashedLineTrace(data, 'OMM', 'red');
    pyldhkMemDashedTrace    = createDashedLineTrace(data, 'SSMM_PYLD_HK', 'blue');
    llMemDashedTrace        = createDashedLineTrace(data, 'SSMM_PYLD_LL', 'orange');
    ssmmTacMemDashedTrace   = createDashedLineTrace(data, 'SSMM_TAC', 'green');

    // RS
    euiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_EUI_SCI', 'magenta');
    metSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_MET_SCI', 'black');
    phiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_PHI_SCI', 'green');
    shiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SHI_SCI', 'orange');
    spiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SPI_SCI', 'blue');
    stxSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_STX_SCI', 'red');
    // IS
    epdSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_EPD_SCI', 'green');
    magSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_MAG_SCI', 'orange');
    rpwSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_RPW_SCI', 'blue');
    swaSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SWA_SCI', 'red');

    rpwSsmmDottedTrace = createDottedLineTraceRPWSelectiveLimit(data, 'SSMM_RPW_SCI', 'blue');


    // IS_Norm
    epdSsmmTrace = createScatterTrace(data, 'EPD_SSMM', 'green');
    magSsmmTrace = createScatterTrace(data, 'MAG_SSMM', 'orange');
    rpwSsmmTrace = createScatterTrace(data, 'RPW_SSMM', 'blue');
    swaSsmmTrace = createScatterTrace(data, 'SWA_SSMM', 'red');

    // RateIS
    epdDownldTrace = createScatterTrace(data, 'EPD_Downld', 'green');
    magDownldTrace = createScatterTrace(data, 'MAG_Downld', 'orange');
    rpwDownldTrace = createScatterTrace(data, 'RPW_Downld', 'blue');
    swaDownldTrace = createScatterTrace(data, 'SWA_Downld', 'red');

    // RateRS
    metDownldTrace = createScatterTrace(data, 'MET_Downld', 'black');
    shiDownldTrace = createScatterTrace(data, 'SHI_Downld', 'orange');
    spiDownldTrace = createScatterTrace(data, 'SPI_Downld', 'blue');
    stxDownldTrace = createScatterTrace(data, 'STX_Downld', 'red');

    // OutputAccumFlsh
    phiAccumTrace = createScatterTrace(data, 'PHI_Accum', 'green');
    euiAccumTrace = createScatterTrace(data, 'EUI_Accum', 'magenta');

    // OutputAccumFlsh
    dlTrace = createScatterTrace(data, 'DL', 'blue');

}

var markerSsmmTrace;
var markerPhiTrace;
var markerMetTrace;
var markerSpiTrace;
var markerShiTrace;
var markerStxTrace;
"use strict";

function extractDataTracesLatencyRs(data) {
    markerSsmmTrace = createMarkerScatterTrace(data, 'SSMM_EUI_SCI_last', 'magenta', 'triangle-down');
    markerPhiTrace = createMarkerScatterTrace(data, 'SSMM_PHI_SCI_last', 'green', 'triangle-up');
    markerMetTrace = createMarkerScatterTrace(data, 'SSMM_MET_SCI_last', 'black', 'star');
    markerSpiTrace = createMarkerScatterTrace(data, 'SSMM_SPI_SCI_last', 'blue', 'octagon');
    markerShiTrace = createMarkerScatterTrace(data, 'SSMM_SHI_SCI_last', 'orange', 'square');
    markerStxTrace = createMarkerScatterTrace(data, 'SSMM_STX_SCI_last', 'red', 'diamond');
}

var epdLatTrace;
var magLatTrace;
var rpwLatTrace;
var swaLatTrace;
function extractDataTracesLatencyIs(data) {

    swaLatTrace = createScatterTrace(data, 'SSMM_SWA_SCI_last', 'red');
    rpwLatTrace = createScatterTrace(data, 'SSMM_RPW_SCI_last', 'blue');
    magLatTrace = createScatterTrace(data, 'SSMM_MAG_SCI_last', 'orange');
    epdLatTrace = createScatterTrace(data, 'SSMM_EPD_SCI_last', 'green');

}

var pyldHkLatTrace;
var ommLatTrace;
var pyldLlLatTrace;
function extractDataTracesLatencyNonSci(data) {
    pyldHkLatTrace = createScatterTrace(data, 'SSMM_PYLD_HK_last', 'blue');
    ommLatTrace = createScatterTrace(data, 'OMM_last', 'orange');
    pyldLlLatTrace = createScatterTrace(data, 'SSMM_PYLD_LL_last', 'green');
}

function extractDataTracesIsNorm(data) {
    // IS_Norm
    epdSsmmTrace = createScatterTrace(data, 'EPD_SSMM',  'green');
    magSsmmTrace = createScatterTrace(data, 'MAG_SSMM',  'orange');
    rpwSsmmTrace = createScatterTrace(data, 'RPW_SSMM',  'blue');
    swaSsmmTrace = createScatterTrace(data, 'SWA_SSMM',  'red');
}

var unusedTrace;
var usedTrace;
var passTrace;
function extractDataTracesUnd(data) {
    unusedTrace   = createScatterTrace(data, 'Overall_Unused_Capacity',  'blue');
    usedTrace   = createScatterTrace(data, 'Overall_Used_Capacity',  'orange');
    passTrace   = createScatterTrace(data, 'Overall_Pass_Capacity',  'black');
}

var unusedOverTrace;
var usedOverTrace;
var passOverTrace;
function extractDataTracesTotAccumDl(data) {
    unusedOverTrace   = createScatterTrace(data, 'Overall_Unused_Capacity',  'blue');
    usedOverTrace   = createScatterTrace(data, 'Overall_Used_Capacity',  'orange');
    passOverTrace   = createScatterTrace(data, 'Overall_Pass_Capacity',  'black');
}

var euiSsmmTrace;
var metSsmmTrace;
var phiSsmmTrace;
var shiSsmmTrace;
var spiSsmmTrace;
var stxSsmmTrace;
function extractDataTracesRsNorm(data) {
    // RS_Norm
    euiSsmmTrace = createScatterTrace(data, 'EUI_SSMM', 'magenta');
    metSsmmTrace = createScatterTrace(data, 'MET_SSMM', 'black');
    phiSsmmTrace = createScatterTrace(data, 'PHI_SSMM', 'green');
    shiSsmmTrace = createScatterTrace(data, 'SHI_SSMM', 'orange');
    spiSsmmTrace = createScatterTrace(data, 'SPI_SSMM', 'blue');
    stxSsmmTrace = createScatterTrace(data, 'STX_SSMM', 'red');
}

var totalRealTrace;
function extractDataTracesTotalReal(data) {
    totalRealTrace   = createScatterTrace(data, 'TotalReal',  'green');
}

// General functions
function createMarkerScatterTrace(data, yKey, color, markerSymbol) {
    return {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: data.map(function (d) {
            var val = d[yKey];
            // If the value is a dash or a plus sign, return null so Plotly won't try to draw it
            // and it won't break the axis numeric scale.
            if (val === '-' || val === '+') {
                return null;
            }
            // Force conversion to a number (float)
            var num = parseFloat(val);
            return isNaN(num) ? null : num;
        }),
        type: 'scatter',
        mode: 'markers',
        name: yKey,
        marker: {
            symbol: markerSymbol,
            color: color,
            size: 10
        }
    };
}

function createScatterTrace(data, yKey, color) {
    return {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: data.map(function (d) {
            return d[yKey];
        }),
        type: 'scatter',
        mode: 'lines',
        name: yKey,
        line: {
            color: color
        }
    };
}
function createDashedLineTrace(data, yKey, color) {
    return {
        x: data.map(function(d) {
            return d.DDATE;
        }),
        y: Array.apply(null, Array(data.length)).map(function() {
            return storeSizesGlobal[yKey];
        }),
        mode: 'lines',
        name: yKey,
        line: {
            color: color,
            dash: 'dash' // Dashed line
        },
    };
}

function createDottedLineTraceRPWSelectiveLimit(data, yKey, color) {
    return {
        x: data.map(function(d) {
            return d.DDATE;
        }),
        y: Array.apply(null, Array(data.length)).map(function() {
            //selective_size_rpw = 2950.0
            return storeSizesGlobal[yKey] - selective_size_rpw;
        }),
        mode: 'lines',
        name: yKey + '_limit',
        line: {
            color: color,
            dash: 'dot' // Dotted line
        },
    };
}

function createDashedLineFixedTrace(data, name, number, color) {
    var dashedLine = {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: Array(data.length).fill(number),
        mode: 'lines',
        name: name,
        line: {
            color: color,
            dash: 'dot' // Dotted line
        }
    };
    return dashedLine;
}


function getMinMaxY(dataY) {
    // Combine all Y-axis data into a single array
    var allYData = [].concat.apply([], dataY.map(function (trace) {
        return trace.y;
    })).filter(function (value) {
        return !isNaN(value);
    });

    // Calculate minY and maxY from the combined data
    var minY = Math.min.apply(Math, allYData);
    var maxY = Math.max.apply(Math, allYData);
    return { minY: minY, maxY: maxY };
}

function chunkMinMax(dataToCalculate) {
    var chunkSize = 1000; // Adjust the chunk size as needed

    // Combine all Y-axis data into a single array for data
    var allYData = [].concat.apply([], dataToCalculate.map(function(trace) {
        return trace.y.filter(function(value) {
            return !isNaN(value);
        });
    }));

    // Split data into chunks
    var splitData = [];
    for (var i = 0; i < allYData.length; i += chunkSize) {
        var chunk = allYData.slice(i, i + chunkSize);
        splitData.push(chunk);
    }

    // Calculate minY and maxY for each chunk
    var minValues = [];
    var maxValues = [];

    splitData.forEach(function(chunk) {
        var chunkMin = Math.min.apply(null, chunk);
        var chunkMax = Math.max.apply(null, chunk);
        minValues.push(chunkMin);
        maxValues.push(chunkMax);
    });

    // Now, minValues and maxValues contain the minimum and maximum values for each chunk
    // Calculate minY and maxY from the combined data
    var minY = Math.min.apply(null, minValues);
    var maxY = Math.max.apply(null, maxValues);

    return { minY: minY, maxY: maxY };
}


function formatTickLabel(date) {
    var parts = date.split('_');
    return parts[0]; // Return the part before the underscore
}

var defHeight = 800;
var defWidth = 1200;
var defHovermode = "closest";
var defTickfont = 22;
var defTitleFontSize = 30;
var defAxisFontSize = 25;
function getLayout(dataOrig, plotTitle, xTitle, yTitle) {
    var minY = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
    var maxY = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5];

    return {
        dragmode: 'drag',
        height: defHeight,
        width: defWidth,
        hovermode: defHovermode,
        title: {
            text: plotTitle,
            font: {
                size: defTitleFontSize
            }
        },
        xaxis: {
            title: {
                text: xTitle,
                show: true,
                font: {
                    size: defAxisFontSize
                }
            },
            tickfont: {
                size: defTickfont
            },
            tickvals: dataOrig.map(function (d, index) {
                return index % Math.ceil(dataOrig.length / 5) === 0 ? d.DDATE : null;
            }),
            ticktext: dataOrig.map(function (d, index) {
                return index % Math.ceil(dataOrig.length / 5) === 0 ? formatTickLabel(d.DDATE) : '';
            }),
            tickangle: 9,
            automargin: true
        },
        yaxis: {
            title: {
                text: yTitle,
                show: true,
                font: {
                    size: defAxisFontSize
                }
            },
            tickfont: {
                size: defTickfont
            },
            range: [minY, maxY],
            // range: [minY || Math.min(...dataOrig.map(d => d.YVALUE)), maxY || Math.max(...dataOrig.map(d => d.YVALUE))],
            automargin: true
        }
    };
}

function plotDataLat(dataArr) {

    var RSLat = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_EUI_SCI_last: obj.SSMM_EUI_SCI_last,
            SSMM_PHI_SCI_last: obj.SSMM_PHI_SCI_last,
            SSMM_SHI_SCI_last: obj.SSMM_SHI_SCI_last,
            SSMM_SPI_SCI_last: obj.SSMM_SPI_SCI_last,
            SSMM_MET_SCI_last: obj.SSMM_MET_SCI_last,
            SSMM_STX_SCI_last: obj.SSMM_STX_SCI_last
        };
    });

    extractDataTracesLatencyRs(RSLat);

    var dataRsLat = [markerSsmmTrace, markerPhiTrace, markerMetTrace, markerSpiTrace, markerShiTrace, markerStxTrace];

    var _getMinMaxY = getMinMaxY(dataRsLat);

    var minY = _getMinMaxY.minY;
    var maxY = _getMinMaxY.maxY;


    var plotTitleRsLat = "Data Latency Remote Sensing Instruments";
    var xTitleRsLat = "Date";
    var yTitleRsLat = "Latency (days)";

    var layoutRS = getLayout(RSLat, plotTitleRsLat, xTitleRsLat, yTitleRsLat, minY, maxY);

    createAndAddToImageList('RSLat', dataRsLat, layoutRS);

    // IS
    var IS = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_SWA_SCI_last: obj.SSMM_SWA_SCI_last,
            SSMM_RPW_SCI_last: obj.SSMM_RPW_SCI_last,
            SSMM_MAG_SCI_last: obj.SSMM_MAG_SCI_last,
            SSMM_EPD_SCI_last: obj.SSMM_EPD_SCI_last
        };
    });

    extractDataTracesLatencyIs(IS);

    var dataIS = [
        swaLatTrace,
        rpwLatTrace,
        magLatTrace,
        epdLatTrace
    ];

    var __ret = getMinMaxY(dataIS);

    var plotTitleIS = "Data Latency In-Situ Instruments";
    var xTitleIS = "Date";
    var yTitleIS = "Latency (days)";

    var layoutIS = getLayout(IS, plotTitleIS, xTitleIS, yTitleIS, __ret.minY, __ret.maxY);

    createAndAddToImageList('ISLat', dataIS, layoutIS);

    // NonSci
    var NonSci = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_PYLD_HK_last: obj.SSMM_PYLD_HK_last,
            OMM_last: obj.OMM_last,
            SSMM_PYLD_LL_last: obj.SSMM_PYLD_LL_last
        };
    });
    extractDataTracesLatencyNonSci(NonSci);

    var dataNonSci = [
        pyldHkLatTrace,
        ommLatTrace,
        pyldLlLatTrace
    ];

    __ret = getMinMaxY(dataNonSci);

    var plotTitleNonSci = "Data Latency HK LL and OMM";
    var xTitleNonSci = "Date";
    var yTitleNonSci = "Latency (days)";

    var layoutNonSci = getLayout(NonSci, plotTitleNonSci, xTitleNonSci, yTitleNonSci, __ret.minY, __ret.maxY);
    createAndAddToImageList('NonSciLat', dataNonSci, layoutNonSci);
}

function plotDataEps(dataArrUnd, dataArrRateAvg, storeSizes, sci_sizes) {
    storeSizesGlobal = storeSizes;
    extractDataTraces(dataArrRateAvg);

    // **** PLOT NonSci **** //
    var dataNonSci = [
        ommMemTrace,
        pyldhkMemTrace,
        llMemTrace,
        ssmmTacMemTrace,
        ommMemDashedTrace,
        pyldhkMemDashedTrace,
        llMemDashedTrace,
        ssmmTacMemDashedTrace
    ];
    var __ret = chunkMinMax(dataNonSci);
    var minYNonSci = __ret.minY;
    var maxYNonSci = __ret.maxY;

// plot
    var plotTitleNonSci = "OMM, PAYLOADHK, LowLat Stores, TAC";
    var xTitleNonSci = "Date";
    var yTitleNonSci = "Stored Data Volume (MiBytes)";

    var NonSci = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            PYLDHK_Mem: item.PYLDHK_Mem,
            OMM_Mem: item.OMM_Mem,
            LL_Mem: item.LL_Mem,
            SSMM_TAC_Mem: item.SSMM_TAC_Mem
        };
    });

    var layoutNonSci = getLayout(NonSci, plotTitleNonSci, xTitleNonSci, yTitleNonSci, minYNonSci, maxYNonSci);


// Create the chart using Plotly for NonSci
    createAndAddToImageList('NonSci', dataNonSci, layoutNonSci);


    // **** PLOT RS **** //
    extractDataTracesRsNorm(dataArrRateAvg);

    // Create an array of objects for the data
    var dataRs = [
        euiSsmmTrace,
        metSsmmTrace,
        phiSsmmTrace,
        shiSsmmTrace,
        spiSsmmTrace,
        stxSsmmTrace,

        euiSsmmDashedTrace,
        metSsmmDashedTrace,
        phiSsmmDashedTrace,
        shiSsmmDashedTrace,
        spiSsmmDashedTrace,
        stxSsmmDashedTrace
    ];


    __ret = chunkMinMax(dataRs);
    var minYrS = __ret.minY;
    var maxYrS = __ret.maxY;

    var RS = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            EUI_SSMM: item.EUI_SSMM,
            MET_SSMM: item.MET_SSMM,
            PHI_SSMM: item.PHI_SSMM,
            SHI_SSMM: item.SHI_SSMM,
            SPI_SSMM: item.SPI_SSMM,
            STX_SSMM: item.STX_SSMM
        };
    });

    // Plot
    var plotTitleRsLat = "Remote Sensing Instruments Fill State";
    var xTitleRsLat = "Date";
    var yTitleRsLat = "Stored Data Volume (MiBytes)";

    var layoutRs = getLayout(RS, plotTitleRsLat, xTitleRsLat, yTitleRsLat, minYrS, maxYrS);


// Create the chart using Plotly
    createAndAddToImageList('Rs', dataRs, layoutRs);


    // **** PLOT IS **** //
    extractDataTracesIsNorm(dataArrRateAvg);
//     // Create an array of objects for the data
    var dataIs = [
        epdSsmmTrace,
        magSsmmTrace,
        rpwSsmmTrace,
        swaSsmmTrace,

        epdSsmmDashedTrace,
        magSsmmDashedTrace,
        rpwSsmmDashedTrace,
        swaSsmmDashedTrace,
        rpwSsmmDottedTrace,
    ];
    __ret = chunkMinMax(dataIs);
    var minYiS = __ret.minY;
    var maxYiS = __ret.maxY;

    var Is = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            EUI_SSMM: item.EUI_SSMM,
            MET_SSMM: item.MET_SSMM,
            PHI_SSMM: item.PHI_SSMM,
            SHI_SSMM: item.SHI_SSMM,
            SPI_SSMM: item.SPI_SSMM,
            STX_SSMM: item.STX_SSMM,
        };
    });

// Plotly
// plot
    var plotTitleIs = "IS Fill states; dashed=store limit; dotted=selective limit";
    var xTitleIs = "Date";
    var yTitleIs = "Stored Data Volume (MiBytes)";

    var layoutIs = getLayout(Is, plotTitleIs, xTitleIs, yTitleIs, minYiS, maxYiS);

// Create the chart using Plotly
    createAndAddToImageList('Is', dataIs, layoutIs);

// **** PLOT IS NORM **** //

    var IS_Norm = dataArrRateAvg.map(function (dataObj) {
        return {
            'DDATE': dataObj.DDATE,
            'EPD_SSMM': 100 * dataObj['EPD_SSMM'] / storeSizes['SSMM_EPD_SCI'],
            'MAG_SSMM': 100 * dataObj['MAG_SSMM'] / storeSizes['SSMM_MAG_SCI'],
            'RPW_SSMM': 100 * dataObj['RPW_SSMM'] / storeSizes['SSMM_RPW_SCI'],
            'SWA_SSMM': 100 * dataObj['SWA_SSMM'] / storeSizes['SSMM_SWA_SCI'],
        };
    });

    extractDataTracesIsNorm(IS_Norm);

// Plotly
    var dataIsNorm = [
        epdSsmmTrace,
        magSsmmTrace,
        rpwSsmmTrace,
        swaSsmmTrace
    ];

    __ret = getMinMaxY(dataIsNorm);

// plot
    var plotTitleIsNorm = "In-Situ Instruments Percentage Fill States";
    var xTitleIsNorm = "Date";
    var yTitleIsNorm = "Percentage Fill State";

    var layoutIsNorm = getLayout(IS_Norm, plotTitleIsNorm, xTitleIsNorm, yTitleIsNorm, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('IsNorm', dataIsNorm, layoutIsNorm);

// **** PLOT RS NORM **** //

    var RS_Norm = dataArrRateAvg.map(function (dataObj) {
        return {
            'DDATE': dataObj.DDATE,
            'STX_SSMM': 100 * dataObj['STX_SSMM'] / storeSizes['SSMM_STX_SCI'],
            'SPI_SSMM': 100 * dataObj['SPI_SSMM'] / storeSizes['SSMM_SPI_SCI'],
            'SHI_SSMM': 100 * dataObj['SHI_SSMM'] / storeSizes['SSMM_SHI_SCI'],
            'PHI_SSMM': 100 * dataObj['PHI_SSMM'] / storeSizes['SSMM_PHI_SCI'],
            'MET_SSMM': 100 * dataObj['MET_SSMM'] / storeSizes['SSMM_MET_SCI'],
            'EUI_SSMM': 100 * dataObj['EUI_SSMM'] / storeSizes['SSMM_EUI_SCI'],
        };
    });

    extractDataTracesRsNorm(RS_Norm);

// Plotly
    var dataRsNorm = [
        euiSsmmTrace,
        metSsmmTrace,
        phiSsmmTrace,
        shiSsmmTrace,
        spiSsmmTrace,
        stxSsmmTrace,
    ];

    __ret = getMinMaxY(dataRsNorm);

// plot
    var plotTitleRsNorm = "Remote Sensing Instruments Percentage Fill State";
    var xTitleRsNorm = "Date";
    var yTitleRsNorm = "Percentage Fill State";

    var layoutRsNorm = getLayout(RS_Norm, plotTitleRsNorm, xTitleRsNorm, yTitleRsNorm, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RsNorm', dataRsNorm, layoutRsNorm);


// **** PLOT ratesRs **** //

// Convert data for ratesRs
    var ratesRs = dataArrRateAvg.map(function (dataObj) {
        return {
            DDATE: dataObj.DDATE,
            STX_Downld: dataObj.STX_Downld,
            SPI_Downld: dataObj.SPI_Downld,
            SHI_Downld: dataObj.SHI_Downld,
            MET_Downld: dataObj.MET_Downld,
        };
    });

// Plotly for ratesRs
    var dataratesRs = [
        stxDownldTrace,
        spiDownldTrace,
        shiDownldTrace,
        metDownldTrace,
    ];

    __ret = getMinMaxY(dataratesRs);

// Plot
    var plotTitleratesRs = "Remote Sensing Instruments output rates";
    var xTitleratesRs = "Date";
    var yTitleratesRs = "Rates b/s";

    var layoutratesRs = getLayout(ratesRs, plotTitleratesRs, xTitleratesRs, yTitleratesRs, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RatesRs', dataratesRs, layoutratesRs);


// **** PLOT RatesIS **** //

// Convert data for RatesIS
    var ratesIs = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            EPD_Downld: item.EPD_Downld,
            MAG_Downld: item.MAG_Downld,
            RPW_Downld: item.RPW_Downld,
            SWA_Downld: item.SWA_Downld,
        };
    });

// Plotly for RatesIS
    var dataRatesIs = [
        epdDownldTrace,
        magDownldTrace,
        rpwDownldTrace,
        swaDownldTrace
    ];

    __ret = getMinMaxY(dataRatesIs);

// Plot
    var plotTitleRatesIs = "In-situ Instruments Output Rates";
    var xTitleRatesIs = "Date";
    var yTitleRatesIs = "Rates (bits/sec)";

    var layoutRatesIs = getLayout(ratesIs, plotTitleRatesIs, xTitleRatesIs, yTitleRatesIs, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RatesIs', dataRatesIs, layoutRatesIs);

    // **** PLOT UND **** //

    // Convert data for UND
    var UND = dataArrUnd.map(function(item) {
        return {
            DDATE: item.DDATE,
            Overall_Unused_Capacity: item.Overall_Unused_Capacity,
            Overall_Used_Capacity: item.Overall_Used_Capacity,
            Overall_Pass_Capacity: item.Overall_Pass_Capacity
        };
    });

    extractDataTracesUnd(UND);
    // Plotly for UND
    var dataUND = [
        usedTrace,
        unusedTrace,
        passTrace,
    ];

    __ret = getMinMaxY(dataUND);

    // Plot
    var plotTitleUnd = "Total, Used and Unused volume per pass";
    var xTitleUnd = "Date";
    var yTitleUnd = "Data volume per pass (MiBytes)";

    var layoutUnd = getLayout(UND, plotTitleUnd, xTitleUnd, yTitleUnd, __ret.minY, __ret.maxY);

    // Create the chart using Plotly
    createAndAddToImageList('Und', dataUND, layoutUnd);

// **** PLOT total Accum DL **** //

    var totAccumDL = UND.reduce(function(acc, curr) {
        acc.push({
            DDATE: curr.DDATE,
            Overall_Unused_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Unused_Capacity) : 0) + parseFloat(curr.Overall_Unused_Capacity),
            Overall_Used_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Used_Capacity) : 0) + parseFloat(curr.Overall_Used_Capacity),
            Overall_Pass_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Pass_Capacity) : 0) + parseFloat(curr.Overall_Pass_Capacity),
        });
        return acc;
    }, []);

    extractDataTracesTotAccumDl(totAccumDL);

// Plotly for UND
    var dataTotAccumDL = [
        unusedOverTrace,
        usedOverTrace,
        passOverTrace,
    ];

    __ret = getMinMaxY(dataTotAccumDL);

// Plot
    var plotTitleTotAccDl = "Downlink Potential Volume";
    var xTitleTotAccDl = "Date";
    var yTitleTotAccDl = "Accumulated downlink potential (MiBytes)";

    var layoutTotAccDl = getLayout(totAccumDL, plotTitleTotAccDl, xTitleTotAccDl, yTitleTotAccDl, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('TotAccumDl', dataTotAccumDL, layoutTotAccDl);

// **** PLOT OutputSSMM_REAL_Tot **** //
// Convert data for OutputSSMM_REAL_Tot

//OMM = AverageData[['OMM_Mem']]
//   Total_HK = np.add(AverageData[['PYLDHK_Mem']],OMM)
    var Total_HK = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total_HK: parseFloat(item.PYLDHK_Mem) + parseFloat(item.OMM_Mem),
        };
    });

// Total_PromptSci = np.add(AverageData[['LL_Mem']],AverageData[['SSMM_TAC_Mem']])
// Total_NonBulk = np.add(Total_HK,Total_PromptSci)
// Assuming dataArr is an array of objects with properties LL_Mem and SSMM_TAC_Mem
    var Total_PromptSci = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total_PromptSci: parseFloat(item.LL_Mem) + parseFloat(item.SSMM_TAC_Mem),
        };
    });

// Assuming Total_HK is an array of objects with properties PYLDHK_Mem and OMM_Mem
    var Total_NonBulk = Total_HK.map(function (item, index) {
        return {
            DDATE: item.DDATE,
            Total_NonBulk: parseFloat(item.Total_HK) + parseFloat(Total_PromptSci[index].Total_PromptSci),
        };
    });

// Total = AverageData[['tot_mem']]
// Assuming dataArr is an array of objects with property tot_mem
    var Total = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total: item.tot_mem,
        };
    });

// Assuming Total and Total_NonBulk are arrays of objects with property Total
    var TotalReal = Total.map(function (item, index) {
        return {
            DDATE: item.DDATE,
            TotalReal: parseFloat(item.Total) + parseFloat(Total_NonBulk[index].Total_NonBulk),
        };
    });

    extractDataTracesTotalReal(TotalReal);

// Plotly
    var sumSciSizes = sci_sizes.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
    }, 0);
    var sciDashed = createDashedLineFixedTrace(dataArrRateAvg, 'SCI_size', sumSciSizes, 'green');
    var dataTotalReal = [
        totalRealTrace,
        sciDashed,
    ];

    __ret = getMinMaxY(dataTotalReal);

// Plot
    var plotTitleTotalReal = "Total SSMM fill state";
    var xTitleTotalReal = "Date";
    var yTitleTotalReal = "Stored Data Volume (MiBytes)";

    var layoutTotalReal = getLayout(TotalReal, plotTitleTotalReal, xTitleTotalReal, yTitleTotalReal, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('TotalReal', dataTotalReal, layoutTotalReal);

// **** PLOT OutputAccumFlsh **** //

// Convert data for OutputAccumFlsh
    var OutputAccumFlsh = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            PHI_Accum: item.PHI_Accum,
            EUI_Accum: item.EUI_Accum,
        };
    });

// Plotly for OutputAccumFlsh
    var dataOutputAccumFlsh = [
        phiAccumTrace,
        euiAccumTrace,
    ];

    __ret = getMinMaxY(dataOutputAccumFlsh);

// Plot
    var plotTitleOutputAccumFlsh = "Accumulated Transferred Data Volume (MiBytes) for PHI and EUI";
    var xTitleOutputAccumFlsh = "Date";
    var yTitleOutputAccumFlsh = "Accumulated Transferred Data Volume (MiBytes)";

    var layoutOutputAccumFlsh = getLayout(OutputAccumFlsh, plotTitleOutputAccumFlsh, xTitleOutputAccumFlsh, yTitleOutputAccumFlsh, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('OutputAccumFlsh', dataOutputAccumFlsh, layoutOutputAccumFlsh);

// **** PLOT Dl **** //

// Convert data for Dl
    var Dl = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            DL: item.DL,
        };
    });

// Plotly for Dl
    var dataDl = [
        dlTrace,
    ];

    __ret = getMinMaxY(dataDl);

// Plot
    var plotTitleDl = "Downlink Rate";
    var xTitleDl = "Date";
    var yTitleDl = "rate bps";

    var layoutDl = getLayout(Dl, plotTitleDl, xTitleDl, yTitleDl, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('Dl', dataDl, layoutDl);



}

function createAndAddToImageList(divId, data, layout) {
    return Plotly.newPlot(divId, data, layout)
        .then(function (plot) {
            return Plotly.toImage(plot, {format: 'png', height: defHeight, width: defWidth});
        })
        .then(function (imgData) {
            imageList.push({data: imgData, filename: divId + '_plot.png'});
        });
}

// Function to launch batch download
function saveImages(images) {
    var zip = new JSZip();
    var promises = imageList.map(function (image) {
        return fetch(image.data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                zip.file(image.filename, blob);
            });
    });

    Promise.all(promises).then(function () {
        zip.generateAsync({ type: 'blob' }).then(function (zipBlob) {
            // Create a link to download the zip file
            var a = document.createElement('a');
            a.href = URL.createObjectURL(zipBlob);
            a.download = 'Plots.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
    });
}

function clearImages() {
    imageList = [];
}

